import React from 'react';
import { Card } from './Card';
import { StatsMonthSelect } from './MonthFilterSelect';

export default function SalesProgressStatsSection({
  description,
  statsMonth,
  onStatsMonthChange,
  children,
}) {
  const showMonthSelect = statsMonth != null && onStatsMonthChange;

  return (
    <Card padding={false} className="overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-prodia-border">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-prodia-text-primary">実績・分析</p>
          <p className="text-xs text-prodia-text-muted mt-0.5">{description}</p>
        </div>
        {showMonthSelect && (
          <StatsMonthSelect value={statsMonth} onChange={onStatsMonthChange} className="flex-shrink-0" />
        )}
      </div>

      <div className="p-4 space-y-6">{children}</div>
    </Card>
  );
}
